import styled from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';
import Button from '@Utils/shared/components/Button-v3';

export const PromotedSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 35px;
  padding: 0 30px;

  @media ${mediaQueries.mobile} {
    padding: 0;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 1;
  margin-right: 15px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  margin-bottom: 3px;
  color: #000;
`;

export const Genre = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.7);
`;

export const PromotedButton = styled(Button)`
  &:disabled {
    color: rgba(255, 255, 255, 0.4);
    background-color: #656776;
  }
`;

export const LearnMoreButton = styled('a')`
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-blue-dark);
  text-align: center;
`;
